import React from "react";
import { Box, BoxProps } from "rebass";
import MaterialCard, {
  CardProps as MaterialCardProps,
} from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

interface CardBaseProps {
  children: React.ReactNode;
  heading: React.ReactNode;
}

type CardProps = CardBaseProps & BoxProps & MaterialCardProps;

const Card = ({ children, heading, ...props }) => (
  <Box as={MaterialCard} {...props}>
    {heading && (
      <CardHeader
        title={heading}
        titleTypographyProps={{ variant: "h2", component: "h2" }}
      />
    )}
    <CardContent style={{ marginTop: 0, paddingTop: 0 }}>
      {children}
    </CardContent>
  </Box>
);

export default Card;
